import React from 'react';

import { useTranslation } from 'react-i18next';

import ColoredButton from 'components/ColoredButton';
import type { AssetRopaReview } from 'config/api/ropaReviews/ropaReviews.types';
import processing_activities_messages from 'messages/processing_activities_messages';

import { canBulkAcceptSubmittedReviews, getBulkAcceptBlockReasons, getSubmittedReviewCount } from '../assetRopaReviewHelpers';
import useStyles from '../ProcessingActivitiesAssetReviewsPage.styles';

type BulkBlockReasonKey = keyof typeof processing_activities_messages.asset_ropa.bulk_accept.block_reasons;

type Props = {
  asset: AssetRopaReview;
  loading?: boolean;
  onBulkAccept: (asset: AssetRopaReview) => void;
};

const BulkAcceptFooter: React.FC<Props> = ({ asset, loading = false, onBulkAccept }) => {
  const { t } = useTranslation();
  const styles = useStyles();
  const blockReasons = getBulkAcceptBlockReasons(asset);
  const canBulkAccept = canBulkAcceptSubmittedReviews(asset);
  const submittedCount = getSubmittedReviewCount(asset);

  if (submittedCount === 0) {
    return null;
  }

  return (
    <div className={styles.assetFooter}>
      <ColoredButton
        className=''
        customColor='secondary'
        disabled={!canBulkAccept || loading}
        icon={false}
        onClick={() => onBulkAccept(asset)}
        showLoader={loading}
        textLike={false}
        variant='outlined'
      >
        {t(processing_activities_messages.asset_ropa.actions.accept_all_submitted)}
      </ColoredButton>
      {!canBulkAccept && (
        <div className={styles.bulkBlocked}>
          {t(processing_activities_messages.asset_ropa.bulk_accept.unavailable_prefix)}{' '}
          {blockReasons
            .map(reason => t(processing_activities_messages.asset_ropa.bulk_accept.block_reasons[reason as BulkBlockReasonKey]))
            .join(' ')}
        </div>
      )}
    </div>
  );
};

export default BulkAcceptFooter;
